const DEMO_STORAGE_KEY = "cls-outlook-actionstep-demo-outcomes";

export const DEMO_ACTIONSTEP_MATTERS = [
  {
    externalId: "demo-1001",
    client: {
      fullName: "Jane Smith (Sample)",
      fileNumber: "DEMO-1001",
    },
    matter: {
      summary: "Criminal law appearance",
      court: "Melbourne Magistrates' Court",
      appearanceType: "Mention",
      nextAppearanceDate: "2026-08-12",
      fundingType: "Legal Aid",
      grantOfAidNumber: "VLA-DEMO-48152",
    },
  },
  {
    externalId: "demo-1002",
    client: {
      fullName: "Michael Brown (Sample)",
      fileNumber: "DEMO-1002",
    },
    matter: {
      summary: "Bail application",
      court: "County Court of Victoria",
      appearanceType: "Bail Application",
      nextAppearanceDate: "2026-08-18",
      fundingType: "LACW",
      grantOfAidNumber: "",
    },
  },
  {
    externalId: "demo-1003",
    client: {
      fullName: "Sarah Nguyen (Sample)",
      fileNumber: "DEMO-1003",
    },
    matter: {
      summary: "Sentence hearing",
      court: "Dandenong Magistrates' Court",
      appearanceType: "Sentence",
      nextAppearanceDate: "2026-08-25",
      fundingType: "Pro Bono",
      grantOfAidNumber: "",
    },
  },
];

export function searchDemoActionstepMatters(query) {
  const term = `${query || ""}`.trim().toLowerCase();
  if (!term) return [];

  return DEMO_ACTIONSTEP_MATTERS.filter((matter) =>
    [
      matter.client?.fullName,
      matter.client?.fileNumber,
      matter.matter?.summary,
      matter.matter?.court,
    ]
      .filter(Boolean)
      .some((value) => value.toLowerCase().includes(term))
  );
}

export function saveDemoActionstepOutcome({ matterId, note, storage = globalThis.sessionStorage }) {
  const record = {
    id: `demo-outcome-${Date.now()}`,
    matterId: `${matterId || ""}`.trim(),
    note: `${note || ""}`.trim(),
    savedAt: new Date().toISOString(),
    simulated: true,
  };

  if (!record.matterId || !record.note) {
    throw new Error("A demo matter and outcome note are required.");
  }

  if (storage?.setItem) {
    storage.setItem(DEMO_STORAGE_KEY, JSON.stringify(record));
  }

  return record;
}
